module.exports = __webpack_public_path__ + "img/tooth-crown.877592e9.svg";